import React from 'react';
import ReactLoading from 'react-loading';
import { courierWithInstantPickup } from "../../../../../services/helpers/courier";

export default function (props) {
    let {
        status,
        orderId,
        deliveryNote,
        courierCompany,
        orderType,
        cancellationReason
    } = props.data;

    let view;
    if (status === 'placed' && (courierWithInstantPickup(courierCompany) || orderType === 'form')){
        view = (
        <div>
            Dikirim Nanti
        </div>
        )
    } else if (status === 'scheduled') {
        view = (
            <div>
            <div>Terjadwal</div>
            <i className="text-muted">{deliveryNote}</i>
            </div>
        )
    } else if (status === 'placed' && !courierWithInstantPickup(courierCompany)) {
        view = (
            <div>
            <div>Dikirim Nanti</div>
            <i className="text-muted">{deliveryNote}</i>
            </div>
        )
    } else if(status === 'confirmed') {
        view = (
        <div>
            <div className="status-container">
            <ReactLoading
                type={'bubbles'}
                color={'#3B196C'}
                height={28}
                width={28}/>
            Sedang mencari kurir
            </div>
        </div>
        )
    } else if(status === 'rejected') {
        view = (
            <div>
                <div className="status-container">
                    Pengiriman ditolak
                </div>
            </div>
        )
    } else if (status === 'courierNotFound') {
        view = (
        <div>
            <div className="status-container">
                Kurir tidak ditemukan
            </div>
        </div>
        )
    } else if (status === 'allocated') {
        view = (
        <div>
            <div>Kurir sudah diinfo</div>
            <i className="text-muted">{deliveryNote}</i>
        </div>
        )
    } else if (status === 'pickingUp') {
        view = (
        <div className="status-container">
            <ReactLoading
            type={'bubbles'}
            color={'#3B196C'}
            height={24}
            width={24}/>
            <strong>Menjemput Barang</strong>
        </div>
        )
    } else if (status === 'picked') {
        view = (
        <div>
            <div>Barang telah dijemput</div>
            <i className="text-muted">{deliveryNote}</i>
        </div>
        )
    } else if (status === 'pending') {
        view = (
            <div>
                <div>Belum Pembayaran</div>
            </div>
        )
    } else if (status === 'returned') {
        view = (
            <div className="text-muted">
                <div>Telah diretur</div>
            </div>
        )
    } else if (status === 'disposed') {
        view = (
            <div className="text-muted">
                <div>Dihancurkan</div>
            </div>
        )
    } else if (status === 'droppingOff') {
        view = (
            <div>Menuju lokasi penerima</div>
        )
    } else if (status === 'returnInTransit') {
        view = (
            <div>Proses pengembalian ke pengirim</div>
        )
    } else if (status === 'delivered') {
        view = (
        <div>
            <b style={{'color':'#000000'}}>✅ Berhasil</b><br/>
            <i className="text-muted">{deliveryNote}</i>
        </div>
        )
    } else if (status === 'rejected') {
        view = (
        <div>
            <b style={{'color':'#000000'}}>Ditolak</b>
            <i className="text-muted">{deliveryNote}</i>
        </div>
        )
    } else if (status === 'onHold') {
        view = (
            <div>
            Ditahan Sementara
            </div>
        )
    } else if (status === 'cancelled') {
        view = (
        <div className="text-muted">
            Cancel<br/>
            {cancellationReason}
        </div>
        )
    }

    return (
        <div>
            {view}
        </div>
    )    
}